import { render, staticRenderFns } from "./PriceTrend.vue?vue&type=template&id=92ce4312&scoped=true"
import script from "./PriceTrend.vue?vue&type=script&lang=js"
export * from "./PriceTrend.vue?vue&type=script&lang=js"
import style0 from "./PriceTrend.vue?vue&type=style&index=0&id=92ce4312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ce4312",
  null
  
)

export default component.exports